
import { useContext } from '@nuxtjs/composition-api';
import useSubscriptionType from '~/composable/useSubscriptionType';


export default {
  name: 'TlmCheckoutDevicesSubscription',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },

  setup (props) {
    const { app } = useContext()
    const {
      loadedSubscriptions,
      containsKeepSubscription,
      fetch,
      cart,
      isActiveProp,
      menuItems,
      moveNumber,
      newNumber,
      changeSubscription
    } = useSubscriptionType(app, props.isActive)
    return {
      loadedSubscriptions,
      containsKeepSubscription,
      fetch,
      cart,
      isActiveProp,
      menuItems,
      moveNumber,
      newNumber,
      changeSubscription
    };
  }
};
